const wexabetMap = {
  "AE": 1, "EH": 2, "IH": 3, "AA": 4, "AH": 5, "EY": 6, "IY": 7, "AY": 8,
  "OW": 9, "UW": 10, "AW": 11, "OY": 12, "UH": 13, "ER": 14,
  "EL": 15, "ILL": 16, "ALL": 17, "AIL": 18, "EEL": 19, "UL": 20,
  "AR": 21, "AIR": 22, "EAR": 23, "OR": 24, "AN": 25
};

/** Phonemes in wexabet order (1–25). */
export const WEXABET_PHONEMES = Object.entries(wexabetMap)
  .sort(([, a], [, b]) => a - b)
  .map(([k]) => k);

/**
 * Returns the text key for a given ID.
 */
export const getPhonemeById = (id) => {
  // Fix: change nucleiMap to wexabetMap
  return Object.keys(wexabetMap).find(key => wexabetMap[key] === id);
};

export default wexabetMap;